export const baseUrl = 'https://introme.co.kr'
